"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanURIQueryParams = cleanURIQueryParams;
exports.getURIQueryParams = getURIQueryParams;
exports.setURIQueryParams = setURIQueryParams;
var _lodash = require("lodash");
function getURIQueryParams() {
  let queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
  const keyValuePairs = {};
  if (queryString && (0, _lodash.isString)(queryString)) {
    // remove `?` from query string if it exists
    if (queryString[0] === "?") {
      queryString = queryString.replace("?", "");
    }
    const queryParams = queryString.split("&");
    for (let param of queryParams) {
      const temp = param.split("=");
      keyValuePairs[temp[0]] = temp[1] ? decodeURIComponent(temp[1].replace(/%2B/g, "%20").replace(/&/g, "%26")) : "";
    }
  }
  return keyValuePairs;
}
function setURIQueryParams(paramsObj) {
  try {
    if (!(0, _lodash.isPlainObject)(paramsObj)) {
      throw new Error("setURIQueryParams argument must be an object");
    }
    const encodedParamsArray = [];
    for (let key in paramsObj) {
      const param = paramsObj[key];
      // ensure param is primitive value first
      isParamPrimitiveValue(param);
      const value = encodeURIComponent(param);
      encodedParamsArray.push(key + "=" + value.replace(/%2B/g, "%20").replace(/ /g, "%20"));
    }
    return encodedParamsArray.join("&");
  } catch (errorMessage) {
    throw new Error(errorMessage);
  }
}
function cleanURIQueryParams(paramsObj) {
  try {
    if (!(0, _lodash.isPlainObject)(paramsObj)) {
      throw new Error("cleanURIQueryParams argument must be an object");
    }
    const cleanParamObj = {};
    for (let key in paramsObj) {
      const param = paramsObj[key];
      // ensure param is primitive value first
      isParamPrimitiveValue(param);
      if (!(0, _lodash.isNil)(param) && !(0, _lodash.isEmpty)(param.toString())) {
        cleanParamObj[key] = param;
      }
    }
    return cleanParamObj;
  } catch (errorMessage) {
    throw new Error(errorMessage);
  }
}
function isParamPrimitiveValue(param) {
  if (param !== Object(param)) {
    return true;
  }
  throw new Error("param is not primitive");
}